export default __webpack_public_path__ + "assets/moon-new.2ed69244.svg";